import React from 'react';
import ReactDOM from 'react-dom';
import {
  MethodCallContainer,
  PageTitleContainer,
  SearchBarContainer,
  ResponseSampleContainer,
} from './containers';
import { AppProvider } from './context';
import { Router } from '@reach/router';
import { useState } from 'react';


function Wrapper() {

  const [nodeResponse, setNodeResponse] = useState('')

  return (
    <AppProvider>

      <div class="container-fluid content">

        {/* Title and node URL bar */}

        <PageTitleContainer />
        <SearchBarContainer />

        <div class="row">

          {/* Method and parameters */}

          <div class="col-sm">
            <MethodCallContainer setNodeResponse={setNodeResponse} />
          </div>

          {/* Sample code  */}

          <div class="col-sm">
            <ResponseSampleContainer NodeResponse={nodeResponse} />
          </div>

        </div>
      </div>
    </AppProvider>
  )
};

const App = () => (
  <Router>
    <Wrapper default />
    <Wrapper path="/:web3URL" />
    <Wrapper path="/:web3URL/:web3Lib" />
    <Wrapper path="/:web3URL/:web3Lib/:currentMethod" />
    <Wrapper path="/:web3URL/:web3Lib/:currentMethod/*formArgs" />
  </Router>
);

ReactDOM.render(<App />, document.querySelector('#root'));
